import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getChannelDisplayName(channel: string): string {
  switch (channel.toLowerCase()) {
    case 'facebook': return 'FB'
    case 'whatsapp': return 'WhatsApp'
    case 'sms': return 'SMS'
    case 'email': return 'Email'
    case 'web': return 'Web'
    case 'portal': return 'Portal'
    default: return channel.toUpperCase()
  }
}
